export enum SellerView {
  GRID = 'GRID',
  KANBAN = 'KANBAN',
}
